import { FC, useState, ReactNode } from "react";
import { FILE_TYPES } from "../../../domain/constants";
import { maxFileSizeBytes, maxFilesSizeMb } from "../../../Config";
import _ from "lodash";
import CustomError from "../../../custom-components/form-inputs/CustomError";
import { useTranslation } from "react-i18next";
import CustomPopup from "../../../custom-components/CustomPopup";

interface ImagePreviewProps {
    preview: string;
}

interface AddImageButtonProps {
    Button: ReactNode;
    ImagePreview: FC<ImagePreviewProps>;
    onFileAddPopupContent?: ReactNode;
    onFileAdd: (file: File) => void;
}

const AddImageButton: FC<AddImageButtonProps> = (props) => {
    const [isVisible, setIsVisible] = useState(false);
    const [errorKey, setErrorKey] = useState("");
    const [preview, setPreview] = useState("");
    const { t } = useTranslation();
    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsVisible(false);
        const file = event.target.files?.[0];
        if (!file) return;
        if (!FILE_TYPES.includes(_.get(file, "type", "/").split("/")[1])) {
            setErrorKey(t("errors.validation.photos.invalidFileType"));
            return;
        }
        if (file.size > maxFileSizeBytes) {
            setErrorKey(t("errors.validation.photos.exceededFileSize", { value: maxFilesSizeMb }));
            return;
        }
        setErrorKey(null);
        const reader = new FileReader();
        reader.onload = async () => {
            const imageDataUrl = reader.result as string;
            setPreview(imageDataUrl);
        };
        reader.readAsDataURL(file);
        if (props.onFileAdd) {
            props.onFileAdd(file);
        }
    };

    return (
        <div className="flex flex-col items-center dmin5:mr-[70px] dmax5:mb-6">
            <props.ImagePreview preview={preview || ""} />
            <label onClick={() => setIsVisible(true)} style={{ cursor: "pointer" }}>
                {props.Button}
                <input
                    type="file"
                    accept={FILE_TYPES.join(",")}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                />
            </label>
            <CustomError
                className="text-center mt-2 dmax2:mt-1 dmin2:max-w-[210px] di6:max-w-[184px] tmax5:max-w-[280px]"
                errorKey={errorKey}
            />
            {props.onFileAddPopupContent && (
                <CustomPopup
                    isVisible={isVisible}
                    setIsVisible={setIsVisible}
                    closingCrossClassName="hidden"
                    wrapClassName="bg-transparent"
                    skipScrollUnlock
                >
                    {props.onFileAddPopupContent}
                </CustomPopup>
            )}
        </div>
    );
};

export default AddImageButton;
